import { ConsumerPostSubmissionFailedView } from './components/consumer-post-submission-failed-view/consumer-post-submission-failed-view.component'

export const ConsumerPostSubmissionFailed = () => {
  return <ConsumerPostSubmissionFailedView />
}
